<div class="back-close-btns-wrapper">
  <span class="back-to-profile" *ngIf="isBackBtnEnabled">
    <a (click)="backButtonEvent()">
      <cigna-icon
        type="chevron-thin-left"
        class="icon-nav-arrow-back"
      ></cigna-icon>
      Back
    </a>
  </span>

  <div class="close" *ngIf="isCloseBtnEnabled && renderMode === 'dialogModal'">
    <button
      data-test-id="closeLink"
      cg-mat-btn-type="link"
      aria-label="close"
      class="dialog-close-wrapper"
      (click)="closeButtonEvent()"
    >
      <mat-icon
        aria-hidden="true"
        class="dialog-close-icon black-icon"
      ></mat-icon>
    </button>
  </div>
</div>
